export const SITE = {
    brand: "Senso Unico",
    tagline: "Pizza al Taglio & Rotonda a Castel d'Ario.",
    address: "Via XX Settembre 26, 46033 Castel d'Ario (MN)",
    addressNote: "Davanti alla chiesa",
    phone: "0376 661280",
    phoneRaw: "+390376661280",
    whatsappRaw: "393381073063",
    reservationNote: "È gradita la prenotazione",
    tagliePrice: "3,50",
    hours: [
        { day: "Lunedì", value: "17:30 — 22:00" },
        { day: "Martedì", value: "Chiuso" },
        { day: "Mercoledì", value: "17:30 — 22:00" },
        { day: "Giovedì", value: "17:30 — 22:00" },
        { day: "Venerdì", value: "17:30 — 22:00" },
        { day: "Sabato", value: "16:00 — 22:00" },
        { day: "Domenica", value: "16:00 — 22:00" },
    ],
    mapEmbed:
        "https://www.google.com/maps?q=Via+XX+Settembre+26,+46033+Castel+d'Ario+MN&output=embed",
    mapLink:
        "https://www.google.com/maps/search/?api=1&query=Pizzeria+Senso+Unico+Castel+d'Ario",
};

export const MANIFESTO_CHAPTERS = [
    {
        id: "01",
        title: "FARINA",
        text: "Impasto a lunga lievitazione. Ore di pura attesa per una leggerezza che non hai mai provato.",
        image:
            "https://images.pexels.com/photos/32293385/pexels-photo-32293385.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "02",
        title: "INGREDIENTI",
        text: "Solo materie prime selezionate: mozzarella filante, pomodoro maturo, salumi scelti, verdure di stagione. La qualità non si nasconde — si sente al primo morso.",
        image:
            "https://images.pexels.com/photos/1435904/pexels-photo-1435904.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "03",
        title: "PASSIONE",
        text: "Ogni pizza è un viaggio. Un percorso a senso unico che dalle mani porta al gusto assoluto.",
        image:
            "https://images.pexels.com/photos/21792440/pexels-photo-21792440.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
];

// Prezzi indicano quelli della ROTONDA. Al TAGLIO tutti i gusti a €3,50.
export const MENU_CATEGORIES = [
    {
        slug: "tradizionali",
        name: "Tradizionali",
        items: [
            { name: "Marinara", desc: "Pomodoro, origano, aglio", price: "3,00" },
            { name: "Stria", desc: "Olio, aglio, origano", price: "3,00" },
            { name: "Margherita", desc: "Pomodoro, mozzarella", price: "4,00" },
            { name: "Napoli", desc: "Pomodoro, mozzarella, acciughe, capperi, olive, origano", price: "5,00" },
            { name: "Prosciutto e Funghi", desc: "Pomodoro, mozzarella, prosciutto cotto, funghi", price: "5,50" },
            { name: "Romana", desc: "Pomodoro, mozzarella, acciughe, origano, capperi", price: "5,00" },
            { name: "Wurstel", desc: "Pomodoro, mozzarella, wurstel", price: "5,00" },
            { name: "Salsiccia e Brié", desc: "Pomodoro, mozzarella, salsiccia, brié", price: "6,00" },
            { name: "Tonno e Cipolla", desc: "Pomodoro, mozzarella, tonno, cipolla", price: "6,00" },
            { name: "Inferno", desc: "Pomodoro, mozzarella, salamino piccante, capperi, acciughe", price: "6,50" },
            { name: "Quattro Formaggi", desc: "Pomodoro, mozzarella, philadelphia, verde, scamorza", price: "6,50" },
            { name: "Verde e Crudo", desc: "Pomodoro, mozzarella, verde, prosciutto di Parma", price: "7,00" },
        ],
    },
    {
        slug: "verdure",
        name: "Verdure",
        items: [
            { name: "Funghi Misti", desc: "Pomodoro, mozzarella, funghi misti", price: "6,00" },
            { name: "Italia", desc: "Pomodoro, mozzarella, rucola, pomodorini, grana a scaglie", price: "6,00" },
            { name: "Melanzane", desc: "Pomodoro, mozzarella, melanzane, grana", price: "6,00" },
            { name: "Zingara", desc: "Pomodoro, mozzarella, funghi, peperoni, capperi, olive sott'olio", price: "6,00" },
            { name: "Zucchine e Philadelphia", desc: "Pomodoro, mozzarella, zucchine, philadelphia", price: "6,00" },
            { name: "Ortolana", desc: "Pomodoro, mozzarella, melanzane, zucchine, pomodorini, asparagi", price: "6,50" },
            { name: "Vegetariana", desc: "Pomodoro, mozzarella, radicchio, melanzane, zucchine, patate, asparagi", price: "6,50" },
        ],
    },
    {
        slug: "gustose",
        name: "Le Gustose",
        items: [
            { name: "Calzone", desc: "Pomodoro, mozzarella, prosciutto, funghi", price: "5,50" },
            { name: "Campagnola", desc: "Pomodoro, mozzarella, radicchio, pancetta arrotolata", price: "6,00" },
            { name: "Carbonara", desc: "Pomodoro, mozzarella, pancetta affumicata, uovo, grana", price: "6,00" },
            { name: "Mayo", desc: "Pomodoro, mozzarella, wurstel, patatine fritte, maionese", price: "6,00" },
            { name: "Porky", desc: "Pomodoro, mozzarella, porchetta, patate al forno", price: "6,00" },
            { name: "Porky 2", desc: "Pomodoro, mozzarella, porchetta, patatine fritte, maionese", price: "6,00" },
            { name: "Speciale", desc: "Pomodoro, mozzarella, pancetta arrotolata, aglio, prezzemolo", price: "6,00" },
            { name: "Wurstel e Patatine", desc: "Pomodoro, mozzarella, wurstel, patatine fritte", price: "6,00" },
            { name: "Capricciosa", desc: "Pomodoro, mozzarella, prosciutto, funghi, carciofi, olive", price: "6,50" },
            { name: "Cotto e Patate", desc: "Pomodoro, mozzarella, prosciutto cotto, patate al forno", price: "6,50" },
            { name: "Delizia", desc: "Pomodoro, mozzarella, speck, emmenthal", price: "6,50" },
            { name: "Estate", desc: "Pomodoro, mozzarella, tonno, pomodorini, olive", price: "6,50" },
            { name: "Pepata", desc: "Pomodoro, mozzarella, pancetta affumicata, scamorza, pepe", price: "6,50" },
            { name: "Trevigiana", desc: "Pomodoro, mozzarella, radicchio, speck, grana", price: "6,50" },
            { name: "Boscaiola", desc: "Pomodoro, mozzarella, salsiccia, funghi misti", price: "7,00" },
            { name: "Fantasia", desc: "Pomodoro, mozzarella, pancetta arrotolata, patate al forno, gorgonzola", price: "7,00" },
            { name: "Inverno", desc: "Pomodoro, mozzarella, radicchio, gorgonzola, salsiccia", price: "7,00" },
            { name: "Insomnia", desc: "Pomodoro, mozzarella, salamino piccante, cipolla, peperoni", price: "7,00" },
            { name: "Rambo", desc: "Pomodoro, mozzarella, patate al forno, salsiccia, salamino piccante", price: "7,00" },
            { name: "Superba", desc: "Pomodoro, mozzarella, salamino piccante, funghi misti, scamorza", price: "7,00" },
            { name: "Appetitosa", desc: "Pomodoro, mozzarella, pancetta arrotolata, funghi misti, gorgonzola", price: "7,50" },
            { name: "Bomba", desc: "Pomodoro, mozzarella, prosciutto, funghi, salamino piccante, wurstel, salsiccia", price: "7,50" },
            { name: "Senso Unico", desc: "Pomodoro, mozzarella, pancetta affumicata, salamino piccante, gorgonzola, cipolla — la firma", price: "7,50" },
            { name: "Sfiziosa", desc: "Pomodoro, mozzarella, speck, funghi misti, zucchine", price: "7,50" },
            { name: "Smile", desc: "Pomodoro, mozzarella, salsiccia, salamino, funghi misti, verde", price: "7,50" },
            { name: "Tirolese", desc: "Pomodoro, mozzarella, speck, funghi misti, grana", price: "7,50" },
            { name: "Trentina", desc: "Pomodoro, mozzarella, speck, porcini, mascarpone", price: "7,50" },
            { name: "Zucchine e Gamberetti", desc: "Pomodoro, mozzarella, zucchine, gamberetti, salsa rosa", price: "7,50" },
        ],
    },
    {
        slug: "specialita",
        name: "Specialità",
        items: [
            { name: "Bufala", desc: "Pomodoro, mozzarella di bufala, crudo", price: "7,00" },
            { name: "Bufalina", desc: "Mozzarella di bufala, pomodorini, rucola, grana a scaglie", price: "7,50" },
            { name: "Calde Braci", desc: "Pomodoro, mozzarella, radicchio, taleggio, porchetta", price: "7,50" },
            { name: "Colori d'Autunno", desc: "Pomodoro, mozzarella, patate, speck, porcini, philadelphia", price: "7,50" },
            { name: "Delicata", desc: "Pomodoro, mozzarella, crudo, zucchine, philadelphia", price: "7,50" },
            { name: "Desiderio", desc: "Pomodoro, mozzarella, stracchino, pomodorini, crudo, rucola", price: "7,50" },
            { name: "Divina", desc: "Pomodoro, mozzarella di bufala, crudo di Parma, crema di carciofi, pomodorini", price: "7,50" },
            { name: "Happy Pig", desc: "Pomodoro, mozzarella, porchetta, wurstel, salamino, salsiccia", price: "7,50" },
            { name: "Imperiale", desc: "Pomodoro, mozzarella, crudo di Parma, patè di olive, philadelphia", price: "7,50" },
            { name: "La Ducale", desc: "Pomodoro, mozzarella, salsiccia, crema di zucca, grana", price: "7,50" },
            { name: "Magoo", desc: "Pomodoro, mozzarella, pancetta arrotolata, patate, salamino", price: "7,50" },
            { name: "Nebbia", desc: "Pomodoro, mozzarella, radicchio, scamorza, salamino piccante", price: "7,50" },
            { name: "Olimpo", desc: "Mozzarella di bufala, pomodoro, mascarpone, crudo, rucola", price: "7,50" },
            { name: "Pollon", desc: "Mozzarella, champignon, bresaola, philadelphia, olio tartufato", price: "7,50" },
            { name: "Primavera", desc: "Pomodoro, mozzarella, pomodorini, porcini, crudo, scaglie di grana", price: "7,50" },
            { name: "Sampey", desc: "Pomodoro, mozzarella, misto mare, gratinato", price: "7,50" },
            { name: "Tartufata", desc: "Pomodoro, mozzarella, olio di tartufo, crudo di Parma, mascarpone", price: "7,50" },
            { name: "Valdostana", desc: "Pomodoro, mozzarella, bresaola, patate, taleggio", price: "7,50" },
            { name: "Valtellina", desc: "Pomodoro, mozzarella, bresaola, rucola, grana", price: "7,50" },
            { name: "Vesuvio", desc: "Pomodoro, mozzarella, salamino piccante, grana, verde", price: "7,50" },
            { name: "Viscontea", desc: "Pomodoro, mozzarella, speck, verde, olio tartufato", price: "7,50" },
        ],
    },
    {
        slug: "sfizioserie",
        name: "Sfizioserie",
        items: [
            { name: "Piadine", desc: "Farcita a scelta", price: "—" },
            { name: "Patatine Fritte", desc: "Croccanti, appena fritte", price: "—" },
            { name: "Crocchette di Patate", desc: "Fritte al momento", price: "—" },
            { name: "Anelli di Cipolla", desc: "In pastella dorata", price: "—" },
            { name: "Olive Ascolane", desc: "Ripiene e fritte", price: "—" },
            { name: "Mozzarelline", desc: "Panate e fritte", price: "—" },
        ],
    },
];

export const AGGIUNTE = {
    speciali: {
        price: "2,00",
        items: [
            "Mozzarella di Bufala",
            "Prosciutto Crudo",
            "Bresaola",
            "Gamberetti",
            "Speck",
            "Misto Funghi",
            "Funghi Porcini",
        ],
    },
    altre: {
        price: "1,00",
        note: "Tutte le altre aggiunte",
    },
};
